import React from "react";

export default function SectionLabel({ children, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="block w-8 h-px bg-[#3B82F6]" />
      <span className="font-mono text-[10px] tracking-[0.25em] text-[#3B82F6] uppercase">
        {children}
      </span>
    </div>
  );
}
